import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import _str from "shared/util/_str";
import PhoneInput from "shared/containers/PhoneInput";
import SmsTerms from "./SmsTerms";
import BlacklistedTerms from "../BlacklistedTerms";

import { STATUS_CODES } from "apps/login/util/constants";

import "./Sms.scss";

const SmsPhone = ({ isSubmitting, sendOTPCode, dialingCode, phoneNumber, error }) => {
	const buttonText = isSubmitting ? _str("Submitting…") : _str("Next");
	const blackListedError = error?.type === STATUS_CODES.BLACKLISTED;

	return (
		<form className="oknf oknf--gray login-form">
			{blackListedError && (
				<BlacklistedTerms />
			)}
			<div className="login-fields">
				<PhoneInput />
			</div>

			<SmsTerms />

			<div className="login-actions">
				<input
					type="submit"
					value={buttonText}
					disabled={!dialingCode || !phoneNumber || phoneNumber.length < 4}
					className={classnames("login-actions-button", { "isSubmitting": isSubmitting })}
					onClick={(e) => {
						e.preventDefault();
						sendOTPCode(dialingCode, phoneNumber);
					}}
				/>
			</div>
		</form>
	);
};

SmsPhone.propTypes = {
	isSubmitting: PropTypes.bool.isRequired,
	sendOTPCode: PropTypes.func.isRequired,
	dialingCode: PropTypes.string.isRequired,
	phoneNumber: PropTypes.string.isRequired,
	error: PropTypes.shape({
		type: PropTypes.number,
		message: PropTypes.string,
	}),
};

SmsPhone.defaultProps = {
	error: null,
};

export default SmsPhone;



// WEBPACK FOOTER //
// ./src/apps/login/components/screens/SmsPhone.jsx